var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { runMapiModules } from './modules/allModules';
import * as Rotation from './lib/additional/RotationBase';
import { doWhenP } from './lib/utils';
import getVersion from './lib/getPackageVersion';
import { getPromoCodePromise, fetchTokenNumbers, replacePhoneNumbers, updateRequestWhenAvailable, updateRequestPriority, getRequestData, getRequestIdPromise, setup, setupSigil, } from './lib/Mapi';
import { updateRequest, datalayerPush, datalayerEvent, getFromDataLayer } from './lib/dataLayer';
export function bootstrap(config) {
    return __awaiter(this, void 0, void 0, function* () {
        runMapiModules();
        yield setup(config);
        return Rotation.run();
    });
}
export function bootstrapSigil(config) {
    runMapiModules();
    setupSigil(config);
    return Rotation.run();
}
export { fetchTokenNumbers, updateRequest, updateRequestWhenAvailable, updateRequestPriority, replacePhoneNumbers, datalayerPush, getFromDataLayer, datalayerEvent, getRequestData, doWhenP, getVersion, getPromoCodePromise as getPromoCode, getRequestIdPromise as getRequestId, };
//# sourceMappingURL=index.js.map